import { Chip as MantineChip } from "@mantine/core";

export const Chip = MantineChip;
